import * as _ from 'lodash';
import {getFlatNestedVariationsSpecifics} from '../../../MyAccount/Listings/EbayListing/ebayListingSelectors';
import {getCurrentState} from '../EbayListingsActions/currentState';
import {store} from '../../../App/store';
import {adjustSelection} from 'cl-table/redux/actions';
import {VARIATIONS_TABLE} from '../../../MyAccount/Listings/EbayListing/VariationsSection';
import {VariationsType} from '../../../MyAccount/Inventory/EditProductSelectors';
import {PRODUCT_FORM_NAME} from '../../../MyAccount/Inventory/ProductPage';
import {PRODUCT_VARIATIONS} from '../../../MyAccount/Inventory/consts';
import {change} from 'redux-form';
import {ValueType} from 'cl-form/validation/validators';

export function generateNewVariations(formValues) {
  if (_.isEmpty(formValues)) {
    return {};
  }
  const aspects = []; // prepare for cartesian product
  _.forEach(formValues, (aspectValue, aspectName) => {
    const aspectValues = _.map(aspectValue, value => ({[aspectName]: value}));
    aspects.push(aspectValues);
  });
  const productResult = _.reduce(
    aspects,
    (results, currentSubArray) => {
      return _.flatten(
        _.map(results, resultsVariant => {
          return _.map(currentSubArray, variant => {
            return {...resultsVariant, ...variant};
          });
        })
      );
    },
    [{}]
  );
  const flattenNestedVariationSpecificsNames = getFlatNestedVariationsSpecifics(getCurrentState());
  let newVariations = {};
  _.forEach(productResult, variationProduct => {
    const nestedVariations = _.pickBy(
      variationProduct,
      (_, aspectName) => flattenNestedVariationSpecificsNames[aspectName]
    );
    if (!_.isEmpty(nestedVariations)) {
      const nonNestedVariations = _.pickBy(variationProduct, (_, aspectName) => !nestedVariations[aspectName]);
      _.forEach(nestedVariations, (aspect, aspectName) => {
        const subVariationProduct = _.reduce(
          unflattenNestedVariationsSpecificsIfExist({
            ...{[aspectName]: aspect},
            ...nonNestedVariations,
          }),
          (result, aspectValue, aspectName) => ({...result, ...{[aspectName]: _.toString(aspectValue)}}),
          {}
        );
        newVariations = {...newVariations, ...generateNewVariation(subVariationProduct)};
      });
    } else {
      newVariations = {...newVariations, ...generateNewVariation(variationProduct)};
    }
  });
  return newVariations;
}

export function generateNewVariation(variationProduct) {
  return {
    [createVariationKey(variationProduct)]: {
      VariationSpecifics: variationProduct,
    },
  };
}

export function createVariationKey(VariationSpecifics) {
  const keys = [];
  _.forEach(VariationSpecifics, aspectValue => {
    if (aspectValue) {
      keys.push(aspectValue.trim().replace(/\s+/g, '-'));
    }
  });
  keys.sort();
  return keys.join('_');
}

export function convertSelectionToIDs(selection, ids: ValueType[]) {
  let idsToUpdate = selection.include;
  if (!_.isUndefined(selection.exclude)) {
    if (_.isEmpty(selection.exclude)) {
      return ids;
    }
    idsToUpdate = _.filter(ids, id => _.indexOf(selection.exclude, id) === -1);
  }
  return idsToUpdate;
}

export function adjustVariationsTableSelection(updatedVariations) {
  store.dispatch(
    adjustSelection({
      name: VARIATIONS_TABLE,
      ids: _.keys(updatedVariations),
      count: _.size(updatedVariations),
    })
  );
}

export function unflattenNestedVariationsSpecificsIfExist(data) {
  const flatten = getFlatNestedVariationsSpecifics(getCurrentState());
  const result = {};
  _.forEach(data, (aspectValue, aspectName) => {
    if (aspectName in flatten) {
      const {childName, parentName, parentValue} = flatten[aspectName];
      result[parentName] = _.concat(result[parentName] || [], parentValue);
      result[childName] = _.concat(result[childName] || [], aspectValue);
    } else {
      result[aspectName] = aspectValue;
    }
  });
  return result;
}

export function createSingleVariationsByFormValues(formValues, variationAspectNames) {
  const variationProductObject = _.pick(formValues, variationAspectNames);
  return {
    [createVariationKey(variationProductObject)]: {
      VariationSpecifics: variationProductObject,
      ..._.omit(formValues, variationAspectNames),
    },
  };
}

const flattenVariations = (updatedVariations: VariationsType) => {
  const flatVariations = [];
  _.forEach(updatedVariations, variation => {
    flatVariations.push({..._.omit(variation, 'VariationSpecifics'), ...variation.VariationSpecifics});
  });
  return flatVariations;
};

export const updateVariationsInStore = (updatedVariations, flat = false) => {
  const variations = flat ? flattenVariations(updatedVariations) : _.values(updatedVariations);
  store.dispatch(change(PRODUCT_FORM_NAME, PRODUCT_VARIATIONS, _.isEmpty(variations) ? '' : variations));
};

export const getUnusedVariations = (currentVariations, variationsSpecificSet) => {
  const allPossibleVariations = generateNewVariations(variationsSpecificSet);
  return _.omit(allPossibleVariations, _.keys(currentVariations));
};
